import React from "react"
import { useFormContext, useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { useProjectColorOptions } from "shared/lib/useProjectColorOptions"
import { WithClassName } from "shared/types/WithClassName"
import { ColorInput } from "shared/ui/input/color/ColorInput"
import { Label } from "shared/ui/label/Label"

import { ProjectImage } from "entities/projects/ui/project-image/ProjectImage"

import { useProjectFormContext } from "../contexts/ProjectFormContext"

export const ProjectFormImage = React.memo(({ className }: WithClassName) => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const { isReadonly, isDisabled } = useProjectFormContext()
  const formColor = useWatch({ control, name: "project.ui.color" })
  const colors = useProjectColorOptions()

  return (
    <div className={classNames("project-form__image", className)}>
      <Label variant={isReadonly ? "subtle" : "bold"}>{t("Color.Color")}</Label>
      <ProjectImage color={formColor} />
      {isReadonly ? null : (
        <ColorInput
          readonly={isReadonly}
          disabled={isDisabled}
          colors={colors}
          label={t("Color.Color")}
          name="project.ui.color"
        >
          <ColorInput.Input />
        </ColorInput>
      )}
    </div>
  )
})
